module.exports = __webpack_public_path__ + "img/scene1-2.b3258262.jpg";